import { z } from 'zod';
import { DatiqCellLabelSchema } from '../../datiq-cell-label';

export const DatiqCellChangeSchema = z.object({
    cell: DatiqCellLabelSchema,
    value: z.number(),
    positiveColor: z.string().optional(),
    negativeColor: z.string().optional(),
    neutralColor: z.string().optional(),
    positiveIcon: z.string().optional(),
    negativeIcon: z.string().optional(),
    neutralIcon: z.string().optional(),
    data: z.unknown().optional(),
});

export interface IDatiqCellChange
    extends z.infer<typeof DatiqCellChangeSchema> {}
